import { Injectable } from '@angular/core';
import { FirebaseAnalytics } from '@capacitor-community/firebase-analytics';
import { PlatformchkService } from './platformchk.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    private platformchk: PlatformchkService,
  ) {}

  /**
   * 회원가입
   * @param method email, google, kakao, naver, facebook, apple
   */
  public async signUp(method: string) {
    // method: 'email', 'google', 'kakao'..
    if(this.platformchk.isApp) {
      await FirebaseAnalytics.logEvent({
        name: 'sign_up',
        params: {
          method: method
        }
      });
    }
  }

  /**
   * 로그인 식별
   * @param uid 유저 ID
   */
  public async login(uid: string) {
    if(this.platformchk.isApp) {
      await FirebaseAnalytics.setUserId({
        userId: uid,
      });
    }
  }
}
